export default "__VITE_ASSET__DjkkWZyd__"